import { render, staticRenderFns } from "./epmsa060.vue?vue&type=template&id=66ffe50b&scoped=true"
import script from "./epmsa060.vue?vue&type=script&lang=js"
export * from "./epmsa060.vue?vue&type=script&lang=js"
import style0 from "./epmsa060.vue?vue&type=style&index=0&id=66ffe50b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ffe50b",
  null
  
)

export default component.exports